/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { MyAppsPageEvent, useMyAppsPageDataSelector } from ".";
import { LoadingStatus } from "../../../rootReducer/actions";
import { MyApp } from "../../../api/apiCalls";
import { MainPageEvent, useMainPageDataSelector } from "../../MainUi";
import { history } from "../../../router/router";
import SecondHeader from "../../Common/SecondHeader";
import LoaderPage from "../../Common/LoaderPage";
import TableRow from "./TableRow";
import ErrorPage from "../ErrorPage";
import { MY_APPS_PAGE } from "../../../config.json";

export default function MyAppsPage() {
  const dispatch = useDispatch();

  const pageData = useMyAppsPageDataSelector();
  const mainPageData = useMainPageDataSelector();
  const msisdn = mainPageData.appUser.msisdn;

  useEffect(() => {
    if (!mainPageData.subscribing) {
      dispatch({
        type: MyAppsPageEvent.MY_APPS_PAGE_DATA,
        payload: {
          senderAddress: msisdn,
        },
        token: mainPageData.authToken ? mainPageData.authToken : null,
      });
    }
    return () => {
      dispatch({
        type: MyAppsPageEvent.RESET,
      });
    };
  }, [msisdn, mainPageData.subscribing, mainPageData.authToken, dispatch]);

  const handleUnsubscription = (app: MyApp) => {
    dispatch({
      type: MainPageEvent.SHOW_UNSUBSCRIPTION_MODAL,
      payload: app,
    });
  };

  return (
    <div>
      <SecondHeader key="normal" />
      {mainPageData.authState !== true && history.push("/")}
      {pageData.loadingStatus === LoadingStatus.LOADING_ERROR ? (
        <ErrorPage />
      ) : (
        <div className="container mt-sm-4 mt-0">
          <h4 className="font-weight-bold mb-0">My Apps</h4>
          {pageData.loadingStatus === LoadingStatus.LOADING_SUCCESS ? (
            <div className="table-responsive mt-3 p-0">
              <table className="table table-borderless p-0">
                <thead className="thead-light">
                  <tr>
                    <th>Application Name</th>
                    <th className="text-center">Subscribed Date</th>
                    <th className="text-center">My Rating</th>
                    <th className="text-center">Subscription Cost(BDT)</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {pageData.apps?.length > 0 &&
                    pageData.apps?.map((app) => {
                      return (
                        app && (
                          <TableRow
                            key={app?.appId}
                            app={app}
                            handleUnsubscription={() =>
                              handleUnsubscription(app)
                            }
                          />
                        )
                      );
                    })}
                </tbody>
              </table>
              {!pageData.apps.length && (
                <p className="text-danger text-left ml-3">
                  {MY_APPS_PAGE.NO_SUBSCRIBED_APPS}
                </p>
              )}
            </div>
          ) : (
            <LoaderPage />
          )}
          <p className="text-disclaimer text-left mt-5 mb-0">
            {MY_APPS_PAGE.DISCLAIMER}
          </p>
        </div>
      )}
    </div>
  );
}
